import { createFileRoute } from '@tanstack/react-router';
import { getTitleContextSlice } from '@utils/breadcrumbsUtils';
import { CodeOwner } from '@utils/router.utils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/vulnerabilities/settings/severity-sla/sla/{-$id}/audit/$automationId')(
  {
    beforeLoad: () => getTitleContextSlice('SLA Audit Logs'),
    staticData: {
      owner: CodeOwner.Uvm,
    },
  }
);
